/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Win_Back_Paywall_Benefit_Real_TreeInputs */

const en_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant real trees`)
};

const ar_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ازرع أشجارًا حقيقية`)
};

const de_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echte Bäume pflanzen`)
};

const es_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantar árboles reales`)
};

const fr_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planter des arbres réels`)
};

const it_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta Alberi Veri`)
};

const ja_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本物の木を植える`)
};

const ko_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실제 나무 기부하기`)
};

const pt_br_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plante árvores de verdade`)
};

const ru_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сажайте настоящие деревья`)
};

const th_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้จริง`)
};

const tr_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek Ağaç Dik`)
};

const zh_cn_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`种植真树参与公益`)
};

const zh_tw_win_back_paywall_benefit_real_tree = /** @type {(inputs: Win_Back_Paywall_Benefit_Real_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種植真樹參與公益`)
};

/**
* | output |
* | --- |
* | "Plant real trees" |
*
* @param {Win_Back_Paywall_Benefit_Real_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_paywall_benefit_real_tree = /** @type {((inputs?: Win_Back_Paywall_Benefit_Real_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Paywall_Benefit_Real_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "ar") return ar_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "de") return de_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "es") return es_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "fr") return fr_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "it") return it_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "ja") return ja_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "ko") return ko_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "pt_br") return pt_br_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "ru") return ru_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "th") return th_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "tr") return tr_win_back_paywall_benefit_real_tree(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_paywall_benefit_real_tree(inputs)
	return zh_tw_win_back_paywall_benefit_real_tree(inputs)
});